import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Vibe from "@/components/Vibe";
import QuoteBanner from "@/components/QuoteBanner";
import MenuHighlights from "@/components/MenuHighlights";
import Reviews from "@/components/Reviews";
import Visit from "@/components/Visit";
import StickyCTA from "@/components/StickyCTA";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-espresso font-sans text-cream antialiased">
      <div className="grain-overlay" />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Vibe />
        <QuoteBanner
          testid="quote-banner-1"
          eyebrow="House policy"
          parts={[
            { text: "Felt cute. Might romanticise my whole life over a " },
            { text: "hot chocolate", accent: true },
            { text: " today." },
          ]}
        />
        <MenuHighlights />
        <Reviews />
        <QuoteBanner
          testid="quote-banner-2"
          eyebrow="Fair warning"
          parts={[
            { text: "Come for the coffee, stay because the neon sign " },
            { text: "validated your whole outfit.", accent: true },
          ]}
        />
        <Visit />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
}

export default App;
